module.exports = __webpack_public_path__ + "images/img-16.31ff95da.jpg";